import { Currency } from '@/core/currency/interfaces';

const HNL: Currency = {
    name: 'Honduran Lempira',
    demonym: 'Honduran',
    majorSingle: 'Lempira',
    majorPlural: 'Lempiras',
    codeNumeric: '340',
    symbol: 'L',
    symbolNative: 'L',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'HNL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default HNL;
